import React ,{ useEffect, useState} from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useNavigate, Link } from "react-router-dom";
import { stringify } from "querystring";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from 'react-helmet';
import './setting.css';

type SeoContent = {
  meta_title: string;
  meta_description?: string;
  // Add more fields as needed
};

const Notification: React.FC = () => {

    const dispatch = useDispatch<any>();
    const [soeContent, setSoeContent] = useState<SeoContent | null>(null);

  return (
    <>
    <Helmet>
      <title>{`${soeContent?.meta_title || 'Notifications'}`}</title>
      <meta name="title" content={soeContent?.meta_title || 'E-learning Platform'} />
      <meta name="description" content={soeContent?.meta_description || 'Learn with curated e-learning resources'} />
      <meta name="keywords" content="e-learning, tech-cards, cheat-sheets, tutorials" />
    </Helmet>

      <Header />

      <div className="container py-5">
          <div className="row">

                <Sidebar />

                <div className="col-lg-9">
                    <div className="main-content">
                        <h2 className="mb-4">Notifications</h2>
                        <div className="card">
                            <div className="card-header">Unread Notifications</div>
                            <div className="list-group list-group-flush">
                            <a href="#" className="list-group-item list-group-item-action notification-item unread">
                                <div className="d-flex justify-content-between">
                                <strong>New course available</strong>
                                <small className="notification-time">2 hours ago</small>
                                </div>
                                <p className="mb-0">"Cloud Computing Essentials" has been added to your recommended courses</p>
                            </a>
                            <a href="#" className="list-group-item list-group-item-action notification-item unread">
                                <div className="d-flex justify-content-between">
                                <strong>Assignment graded</strong>
                                <small className="notification-time">1 day ago</small>
                                </div>
                                <p className="mb-0">Your submission for "Python Project" received 92/100</p>
                            </a>
                            <a href="#" className="list-group-item list-group-item-action notification-item unread">
                                <div className="d-flex justify-content-between">
                                <strong>Live session reminder</strong>
                                <small className="notification-time">3 days ago</small>
                                </div>
                                <p className="mb-0">Your live session with mentor starts in 1 hour</p>
                            </a>
                            </div>
                        </div>
                        <div className="card mt-3">
                            <div className="card-header">Earlier Notifications</div>
                            <div className="list-group list-group-flush">
                            <a href="#" className="list-group-item list-group-item-action notification-item">
                                <div className="d-flex justify-content-between">
                                <strong>Course completed</strong>
                                <small className="notification-time">1 week ago</small>
                                </div>
                                <p className="mb-0">Congratulations! You've completed "Web Development Basics"</p>
                            </a>
                            <a href="#" className="list-group-item list-group-item-action notification-item">
                                <div className="d-flex justify-content-between">
                                <strong>New feature available</strong>
                                <small className="notification-time">2 weeks ago</small>
                                </div>
                                <p className="mb-0">Check out our new mobile app with offline learning support</p>
                            </a>
                            <a href="#" className="list-group-item list-group-item-action notification-item">
                                <div className="d-flex justify-content-between">
                                <strong>Payment received</strong>
                                <small className="notification-time">3 weeks ago</small>
                                </div>
                                <p className="mb-0">Your subscription payment has been processed</p>
                            </a>
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            <a href="/notifications" className="btn btn-outline-primary">View All Notifications</a>
                        </div>
                    </div>
                </div>

          </div>
      </div>

      <Footer />
    </>
  );
};

export default Notification;
